export const REVIEW_SUBMIT = 1;
export const VOTE_SUBMIT = 2;
export const STAR_RATING = 'star_rating';
export const STAR_RATING_2 = 'star_rating_2';
export const STAR_RATING_3 = 'star_rating_3';
